import { call, put, takeLatest } from 'redux-saga/effects';
import {deleteCustomer} from '../../../services/customer/customer-service';
import {
    DELETE_CUSTOMER_REQUEST,
    deleteCustomerSuccess,
    deleteCustomerFailure
} from '../actions/delete-customer-actions';

function* deleteCustomerSaga(action) {
    try {
        yield call(deleteCustomer, action.payload);
        yield put(deleteCustomerSuccess(action.payload));
    } catch (e) {
        yield put(deleteCustomerFailure(e.message));
    }
}

export default function* watchDeleteCustomer() {
    yield takeLatest(DELETE_CUSTOMER_REQUEST, deleteCustomerSaga);
}